import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConnectionService } from '../services/connection/connection.service';
import { AuthBase } from './auth.base';
import { AuthenticationService } from '../../user/services/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard extends AuthBase implements CanActivate {
    constructor(authenticationService: AuthenticationService,
                connectionService: ConnectionService) {
        super(authenticationService, connectionService);
    }

    public canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return this.checkAuthorization();
    }
}
